import {asyncLoad} from './.';

export const loadSpecificLeads = invoiceIds => async dispatch =>
  asyncLoad({
    dispatch,
    title: 'leads',
    url: `/leads/bulk?invoiceIds=${invoiceIds.join('&invoiceIds=')}`,
  });

export const loadLeadSources = () => async dispatch =>
  asyncLoad({
    dispatch,
    title: 'Sources',
    url: `/leadSources`,
  });



// WEBPACK FOOTER //
// ./src/actions/leadActions.js